import $ from 'jquery';

export default () => {
    const button = $('.button');
    button.each(function() {
        if ($(this).find('span').length === 0) {
            const text = $(this).text();
            $(this).html(`<span>${text}</span>`);
        }
    });
}



// WEBPACK FOOTER //
// ../src/scripts/modules/button.js